<template>
  <div
    :class="
      isNumber(discountPrice) &&
      'line-through text-xs font-normal text-gray-400 text-nowrap'
    "
  >
    <template v-if="badge && !isNumber(discountPrice)">
      <UBadge color="gray"
        >kr. {{ formatPrice(recurringPrice) }}
        {{ isNumber(discountPrice) ? "" : "/mnd" }}</UBadge
      >
    </template>
    <template v-else>
      kr. {{ formatPrice(recurringPrice) }}
      {{ isNumber(discountPrice) ? "" : "/mnd" }}
    </template>
  </div>

  <div v-if="isNumber(discountPrice)" class="text-nowrap">
    <template v-if="badge">
      <UBadge color="gray"> kr. {{ formatPrice(discountPrice) }} /mnd </UBadge>
    </template>
    <template v-else> kr. {{ formatPrice(discountPrice) }} /mnd </template>
  </div>
</template>

<script lang="ts" setup>
import { useDomainAddOnCatalogStore } from "../../stores/catalog/domain-addon-catalog";
import { formatPrice } from "../../helpers/priceHelpers";
import { isNumber } from "~/helpers/objectHelpers";

const props = withDefaults(
  defineProps<{
    addOnId: number;
    badge?: boolean;
  }>(),
  {
    badge: false,
  }
);

const addonCatalog = useDomainAddOnCatalogStore();

const subscription = computed(() =>
  addonCatalog.getSubscriptionByAddOnId(props.addOnId)
);

const recurringPrice = computed(() => {
  return subscription.value?.priceRecurring?.unitPriceWithDiscount ?? "?";
});

const discountPrice = computed(() => {
  if (!isNumber(recurringPrice.value)) {
    return null;
  }

  const startupPrice = subscription.value?.priceStartup?.unitPriceWithDiscount;

  if (startupPrice === null || startupPrice === undefined) {
    return null;
  }

  if (startupPrice >= recurringPrice.value) {
    return null;
  }

  return subscription.value?.priceStartup?.unitPriceWithDiscount;
});
</script>

<style></style>
